import RoutesList from './routes.list'

export default RoutesList
